// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__29PG_","calendarButtons":"ClockData_calendarButtons__2k7Ti"};